export default function getResponsiveInfo(elm: Element | null | undefined) {
    return elm
        ? window.getComputedStyle(elm, '::after')?.content.replace(/['"]+/g, '')
        : false;
}
